<template>
  <el-empty :description="description" :image-size="imageSize">
    <slot></slot>
  </el-empty>
</template>

<script setup>
defineProps({
  description: {
    type: String,
    default: '暂无数据'
  },
  imageSize: {
    type: Number,
    default: 100
  }
})
</script>

<style scoped>
:deep(.el-empty) {
  padding: 40px 0;
}
</style>
